var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 1.5C5.75329 1.5 1.5 5.75329 1.5 11C1.5 16.2467 5.75329 20.5 11 20.5C16.2467 20.5 20.5 16.2467 20.5 11C20.5 5.75329 16.2467 1.5 11 1.5ZM11.75 6.45V10.25H15.55C15.6605 10.25 15.75 10.3395 15.75 10.45V11.55C15.75 11.6605 15.6605 11.75 15.55 11.75H11.75V15.55C11.75 15.6605 11.6605 15.75 11.55 15.75H10.45C10.3395 15.75 10.25 15.6605 10.25 15.55V11.75H6.45C6.33954 11.75 6.25 11.6605 6.25 11.55V10.45C6.25 10.3395 6.33954 10.25 6.45 10.25H10.25V6.45C10.25 6.33954 10.3395 6.25 10.45 6.25H11.55C11.6605 6.25 11.75 6.33954 11.75 6.45Z",
    fill: "#1677FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add-new.9f81d69397ef201ea298dc7d13aa8f7b.svg";
export { ForwardRef as ReactComponent };